import { useState, useEffect, useContext } from "react";
import { UserContext } from "../../../contexts/UserContext";
import { fetchUserData } from "./fetchUserData";

export async function useRetrieveUser(email) {
  const { setUserDetails } = useContext(UserContext);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email) return;
    console.log("Retriving User", email);

    const getUserData = async () => {
      setLoading(true);
      try {
        const { userAuth, wiMuleToken, wiMuleTokenTimestamp } =
          await fetchUserData(email);

        const userDetails = {
          email: userAuth.email,
          token: userAuth.userToken,
          userName: userAuth.userName,
          userCompany: userAuth.company,
          userAccessLevel: userAuth.accessLevel,
          userImage: userAuth.image,
          userWiMuleToken: wiMuleToken,
          userWiMuleTokenTimestamp: wiMuleTokenTimestamp,
        };

        setUserDetails(userDetails);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getUserData();
  }, [email, setUserDetails]);

  return { loading, error };
}
